<!--
例子： <page-upload :fileList="fileList" :uploadName="data.uploadName"
                       :listType="data.data.listType" :imgWidth="data.data.imgWidth" :imgHeight="data.data.imgHeight" :limit="data.data.limit">
          </page-upload>
介绍：封装的el-upload
      withCredentials  --  支持发送 cookie 凭证信息  default: true
      showFileList  --  是否显示已上传文件列表  default: true
      multiple  --  是否支持多选  default: false
      fileList  --  文件列表  []
      listType  --  列表类型  default: 'text'
      type  --  上传类型 default: 'img'
      imgWidth  --  图片宽度  default: 690
      imgHeight  --  图片高度  default: 394
      limit  --  最大上传个数
      tipText  --  提示文字
      uploadName  --  上传的label
      @uploadSuccess  --  上传成功抛出的方法
-->
<template>
  <!-- :accept="accept" -->
  <el-upload
    :headers="{
      'Content-Type': 'multipart/form-data',
      'Access-Control-Allow-Methods': 'POST,OPTIONS',
    }"
    action=""
    :with-credentials="withCredentials"
    :show-file-list="showFileList"
    :multiple="multiple"
    :limit="limit"
    :file-list="fileList"
    :list-type="listType"
    :accept="accept"
    ref="uploadRef"
    :http-request="uploadFile"
    :on-preview="handlePreview"
    :on-exceed="onExceed"
    :on-remove="uploadRemove"
    :on-success="uploadSuccess"
    :before-upload="beforeUploadFile"
    :disabled="disabled"
  >
    <el-button
      :disabled="disabled"
      v-bind="attr"
      slot="trigger"
      ref="uploadButtonRef"
      v-if="listType != 'picture-card'"
      >{{ uploadName }}</el-button
    >
    <i class="el-icon-plus" v-else></i>
    <div slot="tip" class="el-upload__tip" v-if="showTip">{{ tipText }}</div>
  </el-upload>
</template>

<script>
export default {
  name: "page-upload",
  props: {
    // 支持发送 cookie 凭证信息
    withCredentials: {
      type: Boolean,
      default: true,
    },
    // 是否显示已上传文件列表
    showFileList: {
      type: Boolean,
      default: true,
    },
    // 是否支持多选
    multiple: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    // 文件列表
    fileList: {
      required: true,
      type: Array,
      default: () => [],
    },
    // 列表类型
    listType: {
      default: "text",
    },
    // 上传类型
    type: {
      type: String,
      default: "img",
    },
    // 上传类型限制
    accept: {
      type: String,
      default: "*",
    },
    // 图片宽度
    imgWidth: {
      default: 690,
    },
    // 图片高度
    imgHeight: {
      default: 394,
    },
    // 最大上传个数
    limit: {
      default: 100,
    },
    // 提示
    tipText: {
      default: "上传文件不能超过100M。",
    },
    // 显示提示
    showTip: {
      default: false,
    },
    uploadName: {
      default: "上传文件",
    },
    sizeLimit: {
      type: Number,
      default: 100,
    },
    nottoken: {
      type: Number,
      default: 0,
    },
    attr: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      uploadPercent: 0,
      imageurl_prefix: "",
    };
  },
  methods: {
    // 图文加前缀链接
    addBeforeHref() {
      this.imageurl_prefix = this.zzlCommon.imageurl_prefix;
    },
    // 检查文件
    checkFile(file) {
      const isLt100M = file.size < this.sizeLimit * 1024 * 1024;
      if (!isLt100M) {
        this.$message.error("上传文件大小不能超过 100M!");
      }
      return isLt100M;
    },
    // 检查图片
    checkImg(file) {
      let isFileFormat =
        file.type === "image/jpg" ||
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "application/pdf";
      const isLt10M = file.size < 10485760;
      if (!isFileFormat) {
        this.$message.error("可上传文件包括jpg、jpeg、png");
      }
      if (!isLt10M) {
        this.$message.error(this.tipText);
      }
      return isFileFormat && isLt10M;
    },
    // 上传文件之前
    beforeUploadFile(file) {
      if (file.name.indexOf(",") >= 0) {
        this.$message.error("文件名不能包含特殊字符“,”");
        return false;
      }
      let bool = null;
      if (this.type === "img") {
        bool = this.checkImg(file);
      } else {
        bool = this.checkFile(file);
      }
      return bool;
    },
    // 上传文件
    async uploadFile(file) {
      const loading = this.$loading({
        lock: true,
        text: 0 + "%",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let fd = new FormData();
      fd.append("file", file.file);
      fd.append("not_token", this.nottoken);

      // 文件上传的进度
      let progress = (_event) => {
        this.uploadPercent = ((_event.loaded / _event.total) * 100).toFixed(0);
        loading.text = this.uploadPercent + "%";
      };
      let file_type = "OTHER";
      switch (file.file.type) {
        case "image/png":
        case "image/jpg":
        case "image/jpeg":
          file_type = "IMAGE";
          break;
        case "application/pdf":
          file_type = "PDF";
          break;
        case "audio/mp3":
        case "audio/mpeg":
          file_type = "AUDIO";
          break;
        case "video/mp4":
          file_type = "VIDEO";
      }
      let params = {
        file_type,
        business_type: "ORDERMEAL",
      };

      const res = await this.zzlHttp.upload(
        this.zzlApi.GetSignature,
        params,
        file,
        progress,
        true
      );
      if (res.code === 0) {
        let fileUrl = "";
        // console.log(res);
        let url = res.data.url;
        let prefix = res.data.prefix;
        if (url.charAt(0) != "/" && prefix.charAt(prefix.length - 1) != "/") {
          fileUrl = prefix + "/" + url;
        } else if (
          url.charAt(0) == "/" &&
          prefix.charAt(prefix.length - 1) == "/"
        ) {
          fileUrl = prefix + "/" + url.substring(1);
        } else {
          fileUrl = prefix + url;
        }
        let obj = {
          name: file.file.name,
          url: fileUrl,
          thumbnail: this.type == "img" ? fileUrl : "",
          type: file.file.type,
          backend: this.type == "img" ? fileUrl : "",
          size: file.file.size,
        };
        this.fileList.push(obj);
        this.$emit("uploadSuccess");
      } else {
        this.fileList = [];
        this.$message.error("上传失败");
      }
      loading.close();
      this.uploadPercent = 0;
    },
    // 预览文件
    handlePreview(file) {},
    // 移除已上传文件
    uploadRemove(file) {
      for (let i in this.fileList) {
        if (this.fileList[i].uid === file.uid) {
          this.fileList.splice(i, 1);
          break;
        }
      }
    },
    uploadSuccess(response, file, fileList) {},
    // 超过最大限制
    onExceed() {
      this.$message.warning(
        `有且只能有${this.limit}个文件，请先删除多余的文件`
      );
    },
  },
};
</script>

<style scoped>
</style>
